// extracted by mini-css-extract-plugin
export var contentContainer = "CopyBlockModule-module--contentContainer--3ddcI";
export var copy = "CopyBlockModule-module--copy--1MJAy";